export const types = {
  TOGGLE_DIALOG: 'error/TOGGLE_DIALOG',
};

export const toggleErrorDialog = (message) => ({
  type: types.TOGGLE_DIALOG,
  payload: message
});
